import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "../backoffice.css";

export default function BackofficeLayout() {
  return (
    <div className="bo-layout">
      <Sidebar />
      <div className="bo-main-col">
        <Topbar />
        <main className="bo-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
